import React from 'react';
import ReactPaginate from 'react-paginate';

const normalizePageCount = (pageCount) => {
    const count = Number(pageCount);
    if (!Number.isFinite(count) || count < 0) {
        return 0;
    }
    return Math.floor(count);
};

/**
 * Wrapper around react-paginate that avoids console warnings when pageCount is 0
 * or forcePage is out of range (e.g. forcePage 0 with pageCount 0).
 */
const SafeReactPaginate = ({ pageCount, forcePage, ...rest }) => {
    const safePageCount = normalizePageCount(pageCount);

    if (safePageCount <= 0) {
        return null;
    }

    const paginateProps = {
        ...rest,
        pageCount: safePageCount,
    };

    if (forcePage !== undefined && forcePage !== null) {
        const index = Number(forcePage);
        if (Number.isFinite(index)) {
            paginateProps.forcePage = Math.min(
                Math.max(Math.floor(index), 0),
                safePageCount - 1
            );
        }
    }

    return <ReactPaginate {...paginateProps} />;
};

export default SafeReactPaginate;
